import React from "react";
import styled from "styled-components";
import { useMobile } from "../../utils/mobile";
import { useTranslation } from "react-i18next";

const InputContainer = styled.div(({ isMobile }) => ({
  position: isMobile && "relative",
}));

const Error = styled.div(({ theme }) => ({
  fontSize: 12,
  color: theme.color.error,
}));

const StyledDiv = styled.div(({ error, theme, height }) => ({
  borderRadius: 8,
  border:
    !!error === true ? `1px solid ${theme.color.error}` : `1px solid #57689F`,
  height: height ? height : 42,
  display: "flex",
  paddingInlineEnd: "0.6em",
  paddingInlineStart: "0.6em",
  lineHeight: 1,
}));

const StyleEndImg = styled.img(() => ({
  marginInlineStart: "auto",
  width: 20,
  height: 20,
  alignSelf: "center",
}));

const StyleStartImg = styled.img(() => ({
  width: 20,
  height: 20,
  marginInlineEnd: "0.3em",
  alignSelf: "center",
}));

const StyledInput = styled.input(
  ({ theme, isMobile, value, label, isRtl, endImg }) => ({
    width: endImg
      ? !!isMobile
        ? "86% !important"
        : "100%"
      : !!isMobile
      ? "96% !important"
      : "100%",
    backgroundColor: theme.color.white,
    border: "none",
    "::placeholder": {
      color: "#AFB4B1",
    },
    fontSize: 15,
    textAlign: "start !important",
    lineHeight: 1,
    right: isRtl && (!!isMobile && !!value && !!label ? 12 : 12),
    left: !isRtl && (!!isMobile && !!value && !!label ? 12 : 12),
    top: !!isMobile && !!value && 10,
    position: !!isMobile && !!value ? "absolute" : "inherit",
  })
);

const Label = styled.div(({ theme }) => ({
  fontSize: 15,
  color: theme.color.label,
  textAlign: "start",
  fontWeight: 600,
  marginBottom: 5,
}));

const LabelMobile = styled("div")(({ theme, color, valid, isRtl }) => ({
  fontSize: 13,
  color: valid === false ? theme.color.error : color || theme.color.label,
  fontWeight: 600,
  letterSpacing: 0.32,
  textAlign: "start",
  position: "relative",
  top: -10,
  backgroundColor: "#FFFFFF",
  width: `fit-content`,
  paddingInline: 6,
  left: !isRtl && -7,
  right: isRtl && -7,
  lineHeight: "12px",
  whiteSpace: "nowrap",
  zIndex: 0,
}));

const Input = ({
  label,
  placeholder,
  endImg,
  startImg,
  helperText,
  showPassword,
  type,
  value,
  clearable = false,
  ...props
}) => {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const isMobile = useMobile();

  return (
    <InputContainer style={{ ...props.style }} isMobile={isMobile}>
      {!isMobile && !!label && <Label>{label}</Label>}
      <StyledDiv
        error={!!helperText}
        height={props.style?.height}
        style={{ ...props.style }}>
        {!!startImg && !value && (
          <StyleStartImg src={startImg} alt="input-start-img" />
        )}
        {isMobile && !!label && !!value && (
          <LabelMobile isRtl={isRtl}>{label}</LabelMobile>
        )}
        <StyledInput
          label={label}
          value={value}
          isMobile={isMobile}
          isRtl={isRtl}
          dir={isRtl ? "rtl" : "ltr"}
          placeholder={placeholder || label}
          {...props}
          onChange={props.onChange}
          type={type}
          endImg={!!endImg}
          style={{ ...props.style, marginBottom: 0 }}
        />
        {!!endImg && (
          <StyleEndImg
            src={endImg}
            alt="input-end-img"
            onClick={() => showPassword(props.type === "password")}
          />
        )}
      </StyledDiv>
      {!!helperText && <Error>{helperText}</Error>}
    </InputContainer>
  );
};

export default Input;
